export default __webpack_public_path__ + "static/media/success.e1bf2299.svg";